import script from "./AdminServiceTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminServiceTable.vue?vue&type=script&setup=true&lang=js"

import "./AdminServiceTable.vue?vue&type=style&index=0&id=6df8163b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6df8163b"]])

export default __exports__